/**
 * Created by vblanco on 27/04/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Edicion', Edicion);

    /* @ngInject */
    function Edicion($resource) {
        return $resource('api/admin/edicion/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/edicion/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/edicion/:id'
            },
            'getNombre': {
                method: 'GET',
                url: 'api/public/edicion/getNombre'
            },
            'publicGet': {
                method: 'GET',
                url: 'api/public/edicion/publicGet/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/edicion/findAll'
            },
            'findUsedLetters': {
                method: 'GET',
                isArray: true,
                url: 'api/public/edicion/findUsedLetters'
            },
            'findAllEdiciones': {
                method: 'GET',
                isArray: false,
                url: 'api/public/edicion/findAllEdiciones'
            },
            'publicSearch': {
                method: 'POST',
                url: 'api/public/edicion/publicSearch'
            },
            'adminSearch': {
                method: 'POST',
                url: 'api/public/edicion/adminSearch'
            },
            'filterGis': {
                method: 'POST',
                isArray: false,
                data: 'data',
                url: 'api/public/edicion/filterGis'
            },
            'getRango': {
                method: 'GET',
                isArray: false,
                url: 'api/public/edicion/rango'
            },
            'findByRelacion': {
                method: 'GET',
                isArray: true,
                url: 'api/public/edicion/findByRelacion'
            },
            'exportar': {
                method: 'POST',
                url: 'api/public/edicion/exportar'
            }
        });
    }
})();
